import React from 'react';
import { PulseLoader } from 'react-spinners';
import './Loader.scss';

export const Loader = () => (
  <div className="loading">
    <PulseLoader color="#55555599" loading={true} />
  </div>
);
